import { ReactElement } from "react";

interface SignalProps {
    value: number;
}

const Signal = (props: SignalProps): ReactElement =>
{
    return (
        <div>
            Signal content {props.value}
        </div>
    );
}

export default Signal;